<template>
  <div
    class="video-volume"
    @mousedown.stop
  >
    <div
      :class="{ 'volume-btn': true, 'volume-btn-silent': volume === 0 }"
      @click.stop="showSlider"
    >
      <iconfont
        style="font-size:14px;"
        :name="volume === 0 ? '#icon11-14yinliangjingyinanniu' : '#icon11-13yinlianganniu'"
      ></iconfont>
    </div>
    <div
      v-show="isShowSlider"
      class="volume-scroll"
    >
      <div
        ref="volumeSlider"
        v-dragWhole
        class="volume-slider"
      >
        <div
          class="time-slider-track"
          :style="{
            height: volume + '%'
          }"
        ></div>
        <div
          class="time-slider-mask"
          data-action="click"
        ></div>
        <div
          data-action="handle"
          class="time-slider-handle"
          :style="{ bottom: `calc(${volume}% - 4px)` }"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VideoVolume',
  data() {
    return {
      volume: 100,
      action: '',
      mpos: null,
      isShowSlider: false
    };
  },
  mounted() {
    document.addEventListener('mousedown', this.mouseDownHide);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.mouseDownHide);
  },
  methods: {
    showSlider() {
      this.isShowSlider = !this.isShowSlider;
    },
    mouseDownHide() {
      this.isShowSlider = false;
    },
    dragDown(dis, action) {
      if (action === 'click') {
        let { top: top } = this.$refs.volumeSlider.getBoundingClientRect();
        let pre = Math.round((113 - dis.y + top) / 1.13);
        this.volume = pre > 100 ? 100 : pre <= 0 ? 0 : pre;
        this.$emit('changeData', this.volume);
        return;
      }
      this.action = action;
      this.mpos = {
        val: this.volume,
        y: dis.y
      };
    },
    dragMove(pos) {
      if (this.action === 'handle') {
        let pre = Math.round((this.mpos.y - pos.y) / 1.13 + this.mpos.val);
        this.volume = pre > 100 ? 100 : pre <= 0 ? 0 : pre;
        this.$emit('changeData', this.volume);
      }
    },
    dragUp() {
      this.action = '';
    }
  }
};
</script>
<style lang="scss" scoped>
.video-volume {
  position: relative;
}

.volume-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0px 2px 5px 0px rgba(124, 124, 124, 0.13);
  border-radius: 15px;
  color: #2f58fe;
  cursor: pointer;
}

.volume-scroll {
  position: absolute;
  bottom: 36px;
  left: 5px;
  width: 20px;
  height: 137px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.volume-slider {
  position: relative;
  top: 12px;
  left: 8px;
  width: 4px;
  height: 113px;
  background-color: #ffffff;
  border-radius: 2px;

  .time-slider-track {
    position: absolute;
    background-color: #2f58fe;
    width: 4px;
    left: 0;
    bottom: 0;
    height: 69.1515%;
    border-radius: 2px;
  }

  .time-slider-mask {
    position: absolute;
    width: 4px;
    height: 100%;
    left: 0;
    top: 0;
    cursor: pointer;
    opacity: 0;
  }
  .time-slider-handle {
    position: absolute;
    margin-left: -2px;
    margin-top: -2px;
    bottom: 69.1515%;
    width: 8px;
    height: 8px;
    background-color: #2f58fe;
    cursor: -webkit-grab;
    cursor: grab;
    border-radius: 50%;
    -ms-touch-action: pan-x;
    touch-action: pan-x;
    z-index: 50;
  }
}
@media (max-width: 1600px) {
  .volume-btn {
    width: 26px;
    height: 26px;
    border-radius: 12px;

    > svg {
      transform-origin: center;
      transform: scale(0.9);
    }
  }
  .volume-scroll {
    left: 3px;
  }
}
</style>
